var React = require('react');

function XBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.0001 3.29287C13.8048 3.09761 13.4882 3.09761 13.293 3.29287L9.00006 7.58577L4.70714 3.29287C4.51188 3.09761 4.1953 3.09761 4.00004 3.29287L3.29293 3.99998C3.09767 4.19524 3.09767 4.51182 3.29293 4.70708L7.58585 8.99998L3.29293 13.182C3.09767 13.3772 3.09767 13.6938 3.29293 13.8891L4.00004 14.5962C4.1953 14.7914 4.51188 14.7914 4.70714 14.5962L9.00006 10.4142L13.293 14.7071C13.4882 14.9024 13.8048 14.9024 14.0001 14.7071L14.7072 14C14.9024 13.8047 14.9024 13.4881 14.7072 13.2929L10.4143 8.99998L14.7072 4.70708C14.9024 4.51182 14.9024 4.19524 14.7072 3.99998L14.0001 3.29287Z","fill":"white"}));
}

XBig.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = XBig;

XBig.default = XBig;
